<template lang="pug">
  v-menu(:close-on-content-click='false' :nudge-width='200' v-model='menu' offset-x='')
    //- v-btn(slot='activator' color='indigo' dark='') Menu as Popover
    v-btn(slot='activator' fab='' dark='' small='' color='info')
      v-icon(dark='') person
    v-card
      v-card-title.text-uppercase.justify-center
        strong Sesión Actual
      v-divider

      v-list
        v-list-tile(avatar='')
          v-list-tile-avatar
            img(:src="image_logo" alt='John')
          v-list-tile-content
            v-list-tile-title Estación : {{infoSession.name}}
            v-list-tile-sub-title Sucursal: {{infoSession.location}} 
        v-list-tile
          v-switch(
            label="Impresión por HTML"
            :value="htmlSwitch"
            @click="requestHtmlPrintToggle"
            )
          //- v-list-tile-action
          //-   v-btn(:class="fav ? 'red--text' : ''" icon='' @click='fav = !fav')
          //-     v-icon favorite
      v-card-title.text-uppercase.justify-end.pt-0.pb-2
        strong {{ version }}
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  export default {
    name: 'sessionBox',
    props: {
        infoSession: {
            type: Object,
            required: true,
        },
        htmlPrint: {
            type: Boolean,
            default: JSON.parse(localStorage.getItem('html-print')),
        },
    },
    data: function() {
        return {
            fav: true,
            menu: false,
            image_logo: require('../../assets/posPrint.png'),
            htmlSwitch: false,
        }
    },
    computed: {
      ...mapState('SessionModule', ['htmlPrint']),
      
      /**
       * 
       */
      version() {
        return process.env.VUE_APP_VERSION
      },
    },
    // computed: {},
    methods: {
        requestHtmlPrintToggle(e) {
            e.preventDefault()
            e.stopPropagation()
            this.$emit('toggle:html:print')
        },
        // -- UI Modification
        // -- Data fetching
        // -- Data handling and transformations
        // -- Validations and Error handling
        // -- Other functions
    },
    watch: {
        htmlPrint: {
            handler(v) {
                setTimeout(() => (this.htmlSwitch = v), 50)
            },
            immediate: true,
        },
    },
  }
</script>

<style lang="scss"></style>
